import React from "react";
import { Link, Box, Typography } from "@mui/material";

const LinkIcon = ({ icon: Icon, label, href, ...props }) => {
  return (
    <Link href={href} underline="hover" color="inherit" {...props}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        {Icon && <Icon fontSize="small" />}
        <Typography variant="body2" component="span">
          {label}
        </Typography>
      </Box>
    </Link>
  );
};

export default LinkIcon;
